import React, { useEffect, useState } from "react";
import "../Style/AddItemModal.css";
import Select from "react-select";
import "../Style/Common.css";
import Footer from "../Footer/Footer";
import { useLocation, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  fetchCategories,
  getAttribute,
  getAttributeOptions,
  getBrands,
  getItemsbyItemId,
  getManufacturer,
  updateItem,
} from "../Services/inventoryService";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { useSnackbar } from "notistack";
import {
  MSG_BATCH_NUMBER_MUST_BE_POSITIVE,
  MSG_COST_PRICE_MUST_BE_POSITIVE,
  MSG_COST_PRICE_REQUIRED,
  MSG_DISCOUNT_RATE_MUST_BE_POSITIVE,
  MSG_ITEM_ADDED,
  MSG_ITEM_DETAILS_FETCH_ERROR,
  MSG_ITEM_NAME_REQUIRED,
  MSG_LOT_NUMBER_MUST_BE_POSITIVE,
  MSG_REORDER_POINT_MUST_BE_POSITIVE,
  MSG_SELECT_ATTRIBUTE_OPTION,
  MSG_SELLING_PRICE_MUST_BE_POSITIVE,
  MSG_SELLING_PRICE_REQUIRED,
  MSG_STOCK_QUANTITY_MUST_BE_POSITIVE,
  MSG_STOCK_QUANTITY_REQUIRED,
  MSG_UOM_REQUIRED,
} from "../Constants/MessageConstant";
import {
  LBL_ADD_ATTRIBUTE,
  LBL_BACK,
  LBL_BATCH_NUMBER,
  LBL_COST_PRICE,
  LBL_CREATE_ATTRIBUTES,
  LBL_DESCRIPTION,
  LBL_DISCOUNT_RATE,
  LBL_EXPIRY_DATE,
  LBL_HSN,
  LBL_IAN,
  LBL_ITEM_TYPE,
  LBL_ITEM_TYPE_INVENTORY,
  LBL_ITEM_TYPE_NONINVENTORY,
  LBL_LOT_NUMBER,
  LBL_MULTIPLE_ITEMS,
  LBL_NON_TAXABLE,
  LBL_REORDER_POINT,
  LBL_SAVE,
  LBL_SELLING_PRICE,
  LBL_SKU,
  LBL_STOCK_QUANTITY,
  LBL_TAX_PREFERENCE,
  LBL_TAXABLE,
  LBL_TYPE,
  LBL_TYPE_GOODS,
  LBL_TYPE_SERVICE,
  LBL_UOM_CM,
  LBL_UOM_FT,
  LBL_UOM_GM,
  LBL_UOM_INCH,
  LBL_UOM_KG,
  LBL_UOM_LOT,
  LBL_UOM_LTR,
  LBL_UOM_M,
  LBL_UOM_MM,
  LBL_UOM_PCS,
  LBL_UOM_PK,
  LBL_UPC,
  LBL_WAREHOUSE,
  PLACEHOLDER_SELECT_BRAND,
  PLACEHOLDER_SELECT_CATEGORY_OPTION,
  PLACEHOLDER_SELECT_MANUFACTURER,
  PLACEHOLDER_SELECT_SIZE,
  PLACEHOLDER_SELECT_UOM,
} from "../Constants/LabelConstants";

// Define the type for an inventory item
interface Item {
  id: number;
  itemId: string;
  orgId: string;
  type: "Goods" | "Service";
  name: string;
  sku: string; // Stock keeping unit
  costPrice: number | string;
  sellingPrice: number | string;
  upc: string; // Universal Product code
  ian: string; // Indian Article number
  hsn: string; // International standard book number
  reorderPoint: number | string;
  desc: string;
  brandId: string;
  categoryId: string;
  manufacturerId: string;
  itemType: "Inventory" | "NonInventory";
  taxable: boolean;
  createAttributes: boolean;
  itemAttribute: {
    itemId: string;
    attribute: string | number;
    option: string | number;
    availableOptions: { id: string | number; name: string }[];
  }[];
  taxId: number;
  itemTypeId: string;
  unit: string;
  quantity: number | string;
  uom: string;
  //stockQuantity: number;
  expiryDate: { _seconds: number; _nanoseconds: number } | string;
  batchNumber: number;
  lotNumber: number;
  discountRate: number;
  warehouseId: number;
  warehouse: string;
}
// Define the type for options
type OptionType = {
  id: string;
  label: string;
};

const EditInventory: React.FC = () => {
  const location = useLocation();
  const [saving, setSaving] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [items, setItems] = useState<Item[]>([]);
  const [costPriceError, setCostPriceError] = useState(false);
  const [itemNameError, setItemNameError] = useState(false);
  const [sellingPriceError, setSellingPriceError] = useState(false);
  const [quantityError, setQuantityError] = useState(false);
  const [uomError, setUomError] = useState(false);
  const orgId = localStorage.getItem("orgId") || "";
  const [loading, setLoading] = useState(true);
  const [availableAttributes, setAvailableAttributes] = useState<
    { id: string; name: string }[]
  >([]);
  const [categoryOptions, setCategoryOptions] = useState<OptionType[]>([]);
  const [brandOptions, setBrandOptions] = useState<OptionType[]>([]);
  // const [availableAttributesOption, setAvailableAttributesOption] = useState<
  //   { id: number; name: string }[]
  // >([]);

  const [manufacturerOptions, setManufacturerOptions] = useState<OptionType[]>(
    []
  );
  const validItemTypes: ("Inventory" | "NonInventory")[] = [
    "Inventory",
    "NonInventory",
  ];
  const [newItem, setNewItem] = useState<Omit<Item, "id">>({
    orgId: "",
    itemId: "",
    name: "",
    sku: "",
    costPrice: "",
    sellingPrice: "",
    upc: "",
    ian: "",
    hsn: "",
    reorderPoint: "",
    type: "Goods",
    desc: "",
    brandId: "",
    categoryId: "",
    manufacturerId: "",
    itemType: "Inventory",
    taxable: true,
    createAttributes: true,
    itemAttribute: [
      { itemId: "", attribute: "", option: "", availableOptions: [] },
    ],
    taxId: 0,
    itemTypeId: "",
    unit: "KG",
    quantity: 0,
    uom: "",
    warehouse: "",
    warehouseId: 0, // Add this line
    //stockQuantity: 0,
    discountRate: 0,
    batchNumber: 0,
    expiryDate: { _seconds: Math.floor(Date.now() / 1000), _nanoseconds: 0 },
    lotNumber: 0,
  });
  useEffect(() => {
    const fetchItemDetails = async () => {
      try {
        const state = location.state as {
          itemRowData: { itemId: string; orgId: string };
        };
        const { orgId, itemId } = state.itemRowData;

        const itemData = await getItemsbyItemId(orgId, itemId);
        setNewItem({
          orgId: itemData.orgId,
          itemId: itemData.itemId,
          name: itemData.name,
          sku: itemData.sku,
          costPrice: itemData.costPrice,
          sellingPrice: itemData.sellingPrice,
          upc: itemData?.upc || "",
          ian: itemData?.ian || "",
          hsn: itemData.hsn,
          reorderPoint: itemData.reorderPoint,
          desc: itemData.desc,
          brandId: "",
          categoryId: itemData?.categoryId?.toString() || "",
          manufacturerId: "",
          itemType: validItemTypes.includes(
            itemData?.itemType as "Inventory" | "NonInventory"
          )
            ? (itemData?.itemType as "Inventory" | "NonInventory")
            : "Inventory",
          taxable: itemData.taxable,
          createAttributes: itemData.createAttributes,
          itemAttribute:
            itemData?.attributes?.map((attr) => ({
              itemId: itemData.itemId,
              attribute: attr.attribute || "",
              option: attr.option || "",
              availableOptions: attr.availableOptions,
            })) ?? [],
          type:
            itemData.type === "Goods" || itemData.type === "Service"
              ? itemData.type
              : "Goods",
          taxId: 0,
          itemTypeId: "",
          unit: "KG",
          quantity: itemData.quantity,
          uom: itemData.uom,
          warehouse: itemData.warehouse,
          warehouseId: 1,
          discountRate: itemData.discountRate,
          batchNumber: itemData.batchNumber,
          expiryDate: itemData?.expiryDate
            ? itemData.expiryDate
            : {
                _seconds: Math.floor(Date.now() / 1000),
                _nanoseconds: 0,
              },
          lotNumber: itemData.lotNumber,
        });

        // 🔹 Check if categoryId exists before fetching brands
        if (itemData.categoryId) {
          try {
            const brandResponse = await getBrands(orgId, itemData.categoryId);
            const formattedBrands =
              brandResponse?.map(
                (brand: { brandId: string; brandName: string }) => ({
                  id: brand.brandId,
                  label: brand.brandName,
                })
              ) || [];

            setBrandOptions(formattedBrands);

            // **Find and set the correct brand**
            const selectedBrand = formattedBrands.find(
              (b: { id: string }) => b.id === itemData.brandId?.toString()
            );

            setNewItem((prevItem) => ({
              ...prevItem,
              brandId: selectedBrand?.id || "",
            }));

            // 🔹 Check if brand exists before fetching manufacturers
            if (selectedBrand) {
              try {
                const manufacturerResponse = await getManufacturer(
                  orgId,
                  selectedBrand.id
                );
                const formattedManufacturers =
                  manufacturerResponse?.map(
                    (manufacturer: {
                      manufacturerId: string;
                      manufacturerName: string;
                    }) => ({
                      id: manufacturer.manufacturerId,
                      label: manufacturer.manufacturerName,
                    })
                  ) || [];

                setManufacturerOptions(formattedManufacturers);

                // **Find and set the correct manufacturer**
                const selectedManufacturer = formattedManufacturers.find(
                  (m: { id: string }) =>
                    m.id === itemData.manufacturerId?.toString()
                );
                setNewItem((prevItem) => ({
                  ...prevItem,
                  manufacturerId: selectedManufacturer?.id || "",
                }));
              } catch (manufacturerError) {
                console.error(
                  "Failed to fetch manufacturers:",
                  manufacturerError
                );
              }
            }
          } catch (brandError) {
            console.error("Failed to fetch brands:", brandError);
          }
        }
      } catch (error) {
        console.error("Failed to fetch item details:", error);
        // Swal.fire({
        //   icon: "error",
        //   title: "Error loading item details",
        //   text: "Please refresh the page.",
        // });
        enqueueSnackbar(MSG_ITEM_DETAILS_FETCH_ERROR, {
          variant: "error",
        });
      }
    };

    fetchItemDetails();
  }, []);

  //     //For catagory
  // Fetch attributes from API
  useEffect(() => {
    const fetchAttributes = async () => {
      try {
        const response = await getAttribute();
        if (Array.isArray(response)) {
          setAvailableAttributes(
            response.map((item) => ({ id: item.attributeId, name: item.name }))
          );
        } else {
          console.error("Unexpected response format:", response);
        }
      } catch (error) {
        console.error("Failed to fetch attributes:", error);
      }
    };
    const getCategories = async () => {
      try {
        const categories = await fetchCategories(orgId);
        const formattedOptions = categories?.map(
          (category: { categoryId: any; categoryName: any }) => ({
            id: category.categoryId,
            label: category.categoryName,
          })
        );
        setCategoryOptions(formattedOptions);
      } catch (error) {
        console.error("Error loading categories:", error);
      } finally {
        setLoading(false);
      }
    };

    getCategories();
    fetchAttributes();
  }, []);
  const validateItem = () => {
    const errors: string[] = [];

    // Check required fields
    if (!newItem.name) {
      errors.push(MSG_ITEM_NAME_REQUIRED);
    }
    if (!newItem.costPrice || Number(newItem.costPrice) <= 0) {
      errors.push(MSG_COST_PRICE_MUST_BE_POSITIVE);
    }
    if (!newItem.sellingPrice || Number(newItem.sellingPrice) <= 0) {
      errors.push(MSG_SELLING_PRICE_MUST_BE_POSITIVE);
    }
    if (!newItem.uom) {
      errors.push(MSG_UOM_REQUIRED);
    }
    return errors;
  };

  const handleAddItem = async () => {
    const validationErrors = validateItem();
    if (validationErrors.length > 0) {
      // Swal.fire({
      //   icon: "error",
      //   title: "Validation Errors",
      //   text: validationErrors.join(" "),
      // });
      enqueueSnackbar(validationErrors.join(" "), {
        variant: "error",
      });
      return; // Stop execution if there are validation errors
    }
    setSaving(true);

    //    const response = await updateItem(newItem);
    const formattedItem = {
      ...newItem,
      itemAttribute: newItem.itemAttribute.map((attr) => ({
        ...attr,
        itemId: attr.itemId || null, // Ensure nullable values match
        attribute: attr.attribute || null,
        option: attr.option || null,
        availableOptions: attr.availableOptions.map((opt) => ({
          id: Number(opt.id), // Convert to number
          name: opt.name,
        })),
      })),
    };
    const response = await updateItem(formattedItem);

    if (response.success) {
      setItems([...items, { id: Date.now(), ...newItem }]);
      // Swal.fire({
      //   icon: "success",
      //   title: "Success",
      //   text: "Item updated successfully!",
      //   confirmButtonText: "Ok",
      // });
      enqueueSnackbar(MSG_ITEM_ADDED, {
        variant: "success",
      });
      setSaving(false);
    }
  };

  const handleCategoryBrandManufacturerChange = async (
    field: "category" | "brand" | "manufacturer",
    selectedOption: { id: string } | null
  ) => {
    try {
      if (field === "category") {
        const categoryId = selectedOption?.id || "";
        let formattedBrandOptions: { id: string; label: string }[] = [];

        try {
          const response = await getBrands(orgId, categoryId);
          formattedBrandOptions =
            response?.map((brand: { brandId: string; brandName: string }) => ({
              id: brand.brandId,
              label: brand.brandName,
            })) || [];
        } catch (error: any) {
          if (error.response?.status === 404) {
            console.warn("No brands found for this category.");
          } else {
            console.error("Error fetching brands:", error);
          }
        }

        setBrandOptions(formattedBrandOptions);
        setNewItem({
          ...newItem,
          categoryId,
          brandId: "",
          manufacturerId: "",
        });
        setManufacturerOptions([]); // Reset manufacturers when category changes
      }

      if (field === "brand") {
        const brandId = selectedOption?.id || "";
        let formattedManufacturerOptions: { id: string; label: string }[] = [];

        try {
          const response = await getManufacturer(orgId, brandId);
          formattedManufacturerOptions =
            response?.map(
              (manufacturer: {
                manufacturerId: string;
                manufacturerName: string;
              }) => ({
                id: manufacturer.manufacturerId,
                label: manufacturer.manufacturerName,
              })
            ) || [];
        } catch (error: any) {
          if (error.response?.status === 404) {
            console.warn("No manufacturers found for this brand.");
          } else {
            console.error("Error fetching manufacturers:", error);
          }
        }

        setManufacturerOptions(formattedManufacturerOptions);
        setNewItem({
          ...newItem,
          brandId,
          manufacturerId: "",
        });
      }

      if (field === "manufacturer") {
        const manufacturerId = selectedOption?.id || "";
        setNewItem({
          ...newItem,
          manufacturerId,
        });
      }
    } catch (error) {
      console.error("Unexpected error:", error);
    }
  };

  // const brandOptions = [
  //   { value: "Brand A", label: "Brand A" },
  //   { value: "Brand B", label: "Brand B" },
  // ];

  // const manufacturerOptions = [
  //   { value: "Manufacturer 1", label: "Manufacturer 1" },
  //   { value: "Manufacturer 2", label: "Manufacturer 2" },
  // ];

  // const categoryOptions = [
  //   { value: "Category X", label: "Category X" },
  //   { value: "Category Y", label: "Category Y" },
  // ];

  // const handleUpdateItem = (updatedItem: Item) => {
  //     setItems(items.map((item) => (item.id === updatedItem.id ? updatedItem : item)));
  // };

  // const handleDeleteItem = (id: number) => {
  //     setItems(items.filter((item) => item.id !== id));
  // };
  const handleTaxableChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewItem({ ...newItem, taxable: e.target.value === "Taxable" });
  };

  const handleAttributesChange = () => {
    setNewItem({ ...newItem, createAttributes: !newItem.createAttributes });
  };

  // const handleAddAttribute = () => {
  //   setNewItem({
  //     ...newItem,
  //     itemAttribute: [
  //       ...newItem.itemAttribute,
  //       {
  //         itemId: "",
  //         attribute: "Attribute",
  //         option: "",
  //         availableOptions: [],
  //       },
  //     ],
  //   });
  // };
  const handleAddAttribute = () => {
    if (newItem.itemAttribute.length > 0) {
      const lastAttribute =
        newItem.itemAttribute[newItem.itemAttribute.length - 1];

      if (!lastAttribute.attribute || !lastAttribute.option) {
        // Swal.fire({
        //   title: "Please select attribute and option",
        //   text: "You can't add next attribute without selecting current one",
        //   icon: "warning",
        //   confirmButtonText: "Ok",
        // });
        enqueueSnackbar(MSG_SELECT_ATTRIBUTE_OPTION, {
          variant: "warning",
          autoHideDuration: 3000,
        });
        return;
      }
    }

    setNewItem({
      ...newItem,
      itemAttribute: [
        ...newItem.itemAttribute,
        {
          itemId: "",
          attribute: "Attribute",
          option: "",
          availableOptions: [],
        },
      ],
    });
  };

  // const handleAttributeOptionChange = (
  //   idx: number,
  //   field: "attribute" | "option",
  //   selectedOption: { value: string|number } | null
  // ) => {
  //   const updatedAttributes = [...newItem.itemAttribute];
  //   if (selectedOption) {
  //     updatedAttributes[idx][field] = selectedOption?.value?.toString();//selectedOption.value; // Only set the value if selectedOption is not null
  //   } else {
  //     updatedAttributes[idx][field] = ""; // Optionally set to an empty string if null
  //   }
  //   setNewItem({ ...newItem, itemAttribute: updatedAttributes });
  // };
  const handleAttributeOptionChange = async (
    idx: number,
    field: "attribute" | "option",
    selectedOption: { value: string | number } | null
  ) => {
    const updatedAttributes = [...newItem.itemAttribute];

    if (field === "attribute" && selectedOption) {
      updatedAttributes[idx].attribute = selectedOption.value;
      updatedAttributes[idx].option = ""; // Reset option when attribute changes

      // 🔹 Fetch available options for the selected attribute
      try {
        const options = await getAttributeOptions(selectedOption.value);
        updatedAttributes[idx].availableOptions = options.map((opt) => ({
          id: Number(opt.id), //opt?.id,
          name: opt.name,
        }));
      } catch (error) {
        console.error("Error fetching attribute options:", error);
      }
    } else if (field === "option" && selectedOption) {
      updatedAttributes[idx].option = selectedOption.value;
    }

    setNewItem({ ...newItem, itemAttribute: updatedAttributes });
  };

  /**
   * Removes an attribute option at the given index from the attributes array
   * @param {number} idx The index of the attribute option to remove
   */
  const handleRemoveAttributeOption = (idx: number) => {
    const updatedAttributes = [...newItem.itemAttribute];
    updatedAttributes.splice(idx, 1);
    setNewItem({ ...newItem, itemAttribute: updatedAttributes });
  };
  // Use the useNavigate hook to get the navigate function to move to the view-inventory page if the user clicks the back button
  const navigate = useNavigate();
  // Function to navigate back to the View Inventory page
  const handleBackClick = () => {
    navigate("/dashboard/inventory/view-inventory");
  };

  const uomOptions = [
    { value: "pcs", label: LBL_UOM_PCS },
    { value: "kg", label: LBL_UOM_KG },
    { value: "gm", label: LBL_UOM_GM },
    { value: "cm", label: LBL_UOM_CM },
    { value: "inch", label: LBL_UOM_INCH },
    { value: "m", label: LBL_UOM_M },
    { value: "mm", label: LBL_UOM_MM },
    { value: "ft", label: LBL_UOM_FT },
    { value: "lot", label: LBL_UOM_LOT },
    { value: "pk", label: LBL_UOM_PK },
    { value: "ltr", label: LBL_UOM_LTR },
  ];

  const parseExpiryDate = (
    expiryDate:
      | string
      | { _seconds: number; _nanoseconds: number }
      | Date
      | dayjs.Dayjs
      | null
      | undefined
  ) => {
    if (!expiryDate) return null;

    if (typeof expiryDate === "string") {
      // ✅ If already in string format, return Day.js object
      return dayjs(expiryDate);
    } else if (typeof expiryDate === "object" && "_seconds" in expiryDate) {
      // ✅ Convert Firestore Timestamp to Date
      return new Date(
        expiryDate._seconds * 1000 + expiryDate._nanoseconds / 1e6
      );
    }
    return null; // Invalid case
  };

  return (
    <>
      <div className="page-location">
        <span>Inventory &gt; View Inventory &gt; Edit Inventory</span>
      </div>
      <Container maxWidth="lg" sx={{ padding: 1 }}>
        {/* Add a Back Button Icon */}
        {/* <button onClick={handleBackClick} className="back-button">
              <img src="/icons8-back-arrow-64.png" alt="Back" className="back-icon" />
              Back to View Inventory
          </button> */}
        <button onClick={handleBackClick} className="back-button">
          <i className="fas fa-arrow-left back-icon"></i>
          {LBL_BACK}
        </button>
        {/* <h1 className="heading-add-item">Add New Item</h1> */}
        <div className="type-selection">
          <span className="label-type">{LBL_TYPE} </span>
          <FormControl className="type-selection-row">
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="Goods"
              name="radio-buttons-group"
              value={newItem.type}
              onChange={(e) => {
                if (
                  e.target.value === "Goods" ||
                  e.target.value === "Service"
                ) {
                  setNewItem({ ...newItem, type: e.target.value });
                } else {
                  console.error("Invalid type value");
                }
              }}
              row
            >
              <FormControlLabel
                value="Goods"
                control={<Radio />}
                label={LBL_TYPE_GOODS}
              />
              <FormControlLabel
                value="Service"
                control={<Radio />}
                label={LBL_TYPE_SERVICE}
              />
            </RadioGroup>
          </FormControl>

          <a href="/userguide.pdf" download>
            <img src="/icons8-help-94.png" alt="Help" className="help-link" />
          </a>
        </div>

        <div className="form-add-item">
          <div className="form-column">
            <TextField
              className="input-item-name"
              label="Item Name"
              variant="outlined"
              required
              value={newItem.name}
              onChange={(e) => {
                setNewItem({ ...newItem, name: e.target.value });
                if (e.target.value) {
                  setItemNameError(false);
                }
              }}
              onBlur={() => {
                if (!newItem.name) {
                  setItemNameError(true);
                }
              }}
              error={itemNameError}
              helperText={itemNameError ? MSG_ITEM_NAME_REQUIRED : ""}
              InputLabelProps={{
                style: { color: "black" },
              }}
            />

            {/* <TextField
      className="input-sku"
      label="SKU"
      variant="outlined"
      value={newItem.sku}
      onChange={(e) => setNewItem({ ...newItem, sku: e.target.value })}
    /> */}
            <TextField
              className="input-hsn"
              label={LBL_HSN}
              variant="outlined"
              value={newItem.hsn}
              onChange={(e) => setNewItem({ ...newItem, hsn: e.target.value })}
            />
          </div>
          <div className="form-column">
            <TextField
              className="input-cost-price"
              label={LBL_COST_PRICE}
              type="number"
              variant="outlined"
              required
              value={newItem.costPrice}
              // onChange={(e) => {
              //   setNewItem({ ...newItem, costPrice: e.target.value });
              //   if (e.target.value) {
              //     setCostPriceError(false);
              //   }
              // }}
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value >= 0) {
                  setNewItem({ ...newItem, costPrice: e.target.value });
                  if (e.target.value) {
                    setCostPriceError(false);
                  }
                } else {
                  // Swal.fire({
                  //   icon: "warning",
                  //   title: "Invalid Cost Price",
                  //   text: "Cost Price must be greater than or equalto zero.",
                  // });
                  enqueueSnackbar(MSG_COST_PRICE_MUST_BE_POSITIVE, {
                    variant: "warning",
                  });
                }
              }}
              onBlur={() => {
                if (!newItem.costPrice) {
                  setCostPriceError(true);
                }
              }}
              error={costPriceError}
              helperText={costPriceError ? MSG_COST_PRICE_REQUIRED : ""}
              InputLabelProps={{
                style: { color: "black" },
              }}
            />
            <TextField
              className="input-selling-price"
              label={LBL_SELLING_PRICE}
              type="number"
              variant="outlined"
              required
              value={newItem.sellingPrice}
              // onChange={(e) => {
              //   setNewItem({ ...newItem, sellingPrice: e.target.value });
              //   if (e.target.value) {
              //     setSellingPriceError(false);
              //   }
              // }}
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value >= 0) {
                  setNewItem({ ...newItem, sellingPrice: e.target.value });
                  if (e.target.value) {
                    setSellingPriceError(false);
                  }
                } else {
                  // Swal.fire({
                  //   icon: "warning",
                  //   title: "Invalid Selling Price",
                  //   text: "Selling Price must be greater than or equalto zero.",
                  // });
                  enqueueSnackbar(MSG_SELLING_PRICE_MUST_BE_POSITIVE, {
                    variant: "warning",
                  });
                }
              }}
              onBlur={() => {
                if (!newItem.sellingPrice) {
                  setSellingPriceError(true);
                }
              }}
              error={sellingPriceError}
              helperText={sellingPriceError ? MSG_SELLING_PRICE_REQUIRED : ""}
              InputLabelProps={{
                style: { color: "black" },
              }}
            />
          </div>
          <div className="form-column">
            {/* <TextField
      className="input-upc"
      label="UPC"
      variant="outlined"
      value={newItem.upc}
      onChange={(e) => setNewItem({ ...newItem, upc: e.target.value })}
    />
    <TextField
      className="input-ian"
      label="IAN"
      variant="outlined"
      value={newItem.ian}
      onChange={(e) => setNewItem({ ...newItem, ian: e.target.value })}
    /> */}
            <div className="dropdown-column">
              <Select
                className="input-hsn"
                required
                options={uomOptions}
                value={
                  uomOptions.find((option) => option.value === newItem.uom) ||
                  null
                }
                onChange={(selectedOption) => {
                  setNewItem({ ...newItem, uom: selectedOption?.value || "" });
                  if (selectedOption) {
                    setUomError(false);
                  }
                }}
                onBlur={() => {
                  if (!newItem.uom) {
                    setUomError(true);
                  }
                }}
                placeholder={
                  <span style={{ color: "black" }}>
                    {PLACEHOLDER_SELECT_UOM}
                  </span>
                }
                isSearchable
              />
              {uomError && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {MSG_UOM_REQUIRED}
                </span>
              )}
            </div>
            <TextField
              className="input-hsn"
              label={LBL_STOCK_QUANTITY}
              variant="outlined"
              required
              value={newItem.quantity}
              // onChange={(e) => {
              //   setNewItem({ ...newItem, quantity: e.target.value });
              //   if (e.target.value) {
              //     setQuantityError(false);
              //   }
              // }}
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value >= 0) {
                  setNewItem({ ...newItem, quantity: e.target.value });
                  if (e.target.value) {
                    setQuantityError(false);
                  }
                } else {
                  // Swal.fire({
                  //   icon: "warning",
                  //   title: "Invalid Stock Quantity",
                  //   text: "Stock Quantity must be greater than or equalto zero.",
                  // });
                  enqueueSnackbar(MSG_STOCK_QUANTITY_MUST_BE_POSITIVE, {
                    variant: "warning",
                  });
                }
              }}
              onBlur={() => {
                if (!newItem.quantity) {
                  setQuantityError(true);
                }
              }}
              error={quantityError}
              helperText={quantityError ? MSG_STOCK_QUANTITY_REQUIRED : ""}
              InputLabelProps={{
                style: { color: "black" },
              }}
            />
          </div>
          <div className="form-column">
            {/* <TextField
      className="input-hsn"
      label="HSN"
      variant="outlined"
      value={newItem.hsn}
      onChange={(e) => setNewItem({ ...newItem, hsn: e.target.value })}
    /> */}
            <TextField
              className="input-sku"
              label={LBL_SKU}
              variant="outlined"
              value={newItem.sku}
              onChange={(e) => setNewItem({ ...newItem, sku: e.target.value })}
            />
            <TextField
              className="input-reorder-point"
              label={LBL_REORDER_POINT}
              type="number"
              variant="outlined"
              value={newItem.reorderPoint}
              // onChange={(e) =>
              //   setNewItem({ ...newItem, reorderPoint: e.target.value })
              // }
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value >= 0) {
                  setNewItem({ ...newItem, reorderPoint: e.target.value });
                } else {
                  // Swal.fire({
                  //   icon: "warning",
                  //   title: "Invalid Reorder Point",
                  //   text: "Reorder Point must be greater than or equalto zero.",
                  // });
                  enqueueSnackbar(MSG_REORDER_POINT_MUST_BE_POSITIVE, {
                    variant: "warning",
                  });
                }
              }}
            />
          </div>
          <div className="form-column">
            <TextField
              className="input-hsn"
              label={LBL_LOT_NUMBER}
              type="number"
              variant="outlined"
              value={newItem.lotNumber}
              // onChange={(e) =>
              //   setNewItem({ ...newItem, lotNumber: Number(e.target.value) })
              // }
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value >= 0) {
                  setNewItem({
                    ...newItem,
                    lotNumber: Number(e.target.value),
                  });
                } else {
                  // Swal.fire({
                  //   icon: "warning",
                  //   title: "Invalid Lot Number",
                  //   text: "Lot Number must be greater than or equalto zero.",
                  // });
                  enqueueSnackbar(MSG_LOT_NUMBER_MUST_BE_POSITIVE, {
                    variant: "warning",
                  });
                }
              }}
            />
            <TextField
              className="input-hsn"
              label={LBL_DISCOUNT_RATE}
              type="number"
              variant="outlined"
              value={newItem.discountRate}
              // onChange={(e) =>
              //   setNewItem({ ...newItem, discountRate: Number(e.target.value) })
              // }
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value >= 0) {
                  setNewItem({
                    ...newItem,
                    discountRate: Number(e.target.value),
                  });
                } else {
                  // Swal.fire({
                  //   icon: "warning",
                  //   title: "Invalid Discount Rate",
                  //   text: "Discount Rate must be greater than or equalto zero.",
                  // });
                  enqueueSnackbar(MSG_DISCOUNT_RATE_MUST_BE_POSITIVE, {
                    variant: "warning",
                  });
                }
              }}
            />
          </div>
          <div className="form-column">
            <TextField
              className="input-hsn"
              label={LBL_BATCH_NUMBER}
              type="number"
              variant="outlined"
              value={newItem.batchNumber}
              // onChange={(e) =>
              //   setNewItem({ ...newItem, batchNumber: Number(e.target.value) })
              // }
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value >= 0) {
                  setNewItem({
                    ...newItem,
                    batchNumber: Number(e.target.value),
                  });
                } else {
                  // Swal.fire({
                  //   icon: "warning",
                  //   title: "Invalid Batch Number",
                  //   text: "Batch Number must be greater than or equalto zero.",
                  // });
                  enqueueSnackbar(MSG_BATCH_NUMBER_MUST_BE_POSITIVE, {
                    variant: "warning",
                  });
                }
              }}
            />
            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        className="input-hsn"
        label="Expiry Date"
        minDate={dayjs()}
      />
    </LocalizationProvider> */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                className="input-hsn"
                label={LBL_EXPIRY_DATE}
                minDate={dayjs()}
                value={
                  newItem?.expiryDate
                    ? dayjs(parseExpiryDate(newItem.expiryDate))
                    : null
                } // ✅ Convert before passing
                onChange={(newValue) =>
                  setNewItem({
                    ...newItem,
                    expiryDate: newValue ? newValue?.toISOString() : "", // ✅ Save as ISO string or empty
                  })
                }
              />
            </LocalizationProvider>
          </div>
          <div className="form-column">
            <TextField
              className="input-upc"
              label={LBL_UPC}
              variant="outlined"
              value={newItem.upc}
              onChange={(e) => setNewItem({ ...newItem, upc: e.target.value })}
            />
            <TextField
              className="input-ian"
              label={LBL_IAN}
              variant="outlined"
              value={newItem.ian}
              onChange={(e) => setNewItem({ ...newItem, ian: e.target.value })}
            />
            {/* <div className="dropdown-column">
      <Select
        className="input-hsn"
        required
        options={uomOptions}
        value={
          uomOptions.find((option) => option.value === newItem.uom) ||
          null
        }
        onChange={(selectedOption) => {
          setNewItem({ ...newItem, uom: selectedOption?.value || "" });
          if (selectedOption) {
            setUomError(false);
          }
        }}
        onBlur={() => {
          if (!newItem.uom) {
            setUomError(true);
          }
        }}
        placeholder={<span style={{ color: "black" }}>Select UOM</span>}
        isSearchable
      />
      {uomError && (
        <span style={{ color: "red", fontSize: "12px" }}>
          UOM is required *
        </span>
      )}
    </div>
    <TextField
      className="input-hsn"
      label="Stock Quantity"
      variant="outlined"
      required
      value={newItem.quantity}
      // onChange={(e) => {
      //   setNewItem({ ...newItem, quantity: e.target.value });
      //   if (e.target.value) {
      //     setQuantityError(false);
      //   }
      // }}
      onChange={(e) => {
        const value = Number(e.target.value);
        if (value >= 0) {
          setNewItem({ ...newItem, quantity: e.target.value });
          if (e.target.value) {
            setQuantityError(false);
          }
        } else {
          Swal.fire({
            icon: "warning",
            title: "Invalid Stock Quantity",
            text: "Stock Quantity must be greater than or equalto zero.",
          });
        }
      }}
      onBlur={() => {
        if (!newItem.quantity) {
          setQuantityError(true);
        }
      }}
      error={quantityError}
      helperText={quantityError ? "Stock Quantity is required *" : ""}
      InputLabelProps={{
        style: { color: "black" },
      }}
    /> */}
          </div>
          <div className="form-column">
            <TextField
              className="input-hsn"
              label={LBL_WAREHOUSE}
              variant="outlined"
              value={newItem.warehouse}
              onChange={(e) =>
                setNewItem({ ...newItem, warehouse: e.target.value })
              }
            />
            <TextareaAutosize
              className="textarea-desc"
              placeholder={LBL_DESCRIPTION}
              minRows={4}
              style={{ width: "49%" }}
              value={newItem.desc}
              onChange={(e: { target: { value: any } }) =>
                setNewItem({ ...newItem, desc: e.target.value })
              }
            />
          </div>

          {/* <div className="form-row-dropdown">
      <div className="dropdown-column">
        <Select
          className="dropdown-field"
          options={categoryOptions}
          value={categoryOptions.find((option) => option.id === newItem.categoryId)}
          onChange={(selectedOption) =>
            setNewItem({
              ...newItem,
              categoryId: selectedOption?.id || "",
            })
          }
          placeholder="Select Category"
          isSearchable
        />
      </div>

      <div className="dropdown-column">
        <Select
          className="dropdown-field"
          options={manufacturerOptions}
          value={manufacturerOptions.find(
            (option) => option.id === newItem.manufacturerId
          )}
          onChange={(selectedOption) =>
            setNewItem({
              ...newItem,
              manufacturerId: selectedOption?.id || "",
            })
          }
          placeholder="Select Manufacturer"
          isSearchable
        />
      </div>
      <div className="dropdown-column">
        <Select
          className="dropdown-field"
          options={brandOptions}
          value={brandOptions.find(
            (option) => option.id === newItem.brandId
          )}
          onChange={(selectedOption) =>
            setNewItem({ ...newItem, brandId: selectedOption?.id || "" })
          }
          placeholder="Select Brand"
          isSearchable
        />
      </div>
    </div> */}

          <div className="form-row-dropdown">
            <div className="dropdown-column">
              <Select
                className="dropdown-field"
                options={categoryOptions}
                value={categoryOptions.find(
                  (option) => option.id === newItem.categoryId
                )}
                onChange={(selectedOption) =>
                  handleCategoryBrandManufacturerChange(
                    "category",
                    selectedOption
                  )
                }
                placeholder={PLACEHOLDER_SELECT_CATEGORY_OPTION}
                isSearchable
              />
            </div>

            <div className="dropdown-column">
              <Select
                className="dropdown-field"
                options={brandOptions}
                value={brandOptions.find(
                  (option) => option.id === newItem.brandId
                )}
                onChange={(selectedOption) =>
                  handleCategoryBrandManufacturerChange("brand", selectedOption)
                }
                placeholder={PLACEHOLDER_SELECT_BRAND}
                isSearchable
              />
            </div>

            <div className="dropdown-column">
              <Select
                className="dropdown-field"
                options={manufacturerOptions}
                value={manufacturerOptions.find(
                  (option) => option.id === newItem.manufacturerId
                )}
                onChange={(selectedOption) =>
                  handleCategoryBrandManufacturerChange(
                    "manufacturer",
                    selectedOption
                  )
                }
                placeholder={PLACEHOLDER_SELECT_MANUFACTURER}
                isSearchable
              />
            </div>
          </div>
          <span className="label-type">{LBL_ITEM_TYPE} </span>
          <div className="type-selection">
            <FormControl className="type-selection-row">
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="itemType"
                value={newItem.itemType}
                onChange={(e) => {
                  const itemType = e.target.value;
                  if (itemType === "Inventory" || itemType === "NonInventory") {
                    setNewItem({ ...newItem, itemType });
                  } else {
                    console.error(`Invalid item type: ${itemType}`);
                  }
                }}
                row
              >
                <div className="radio-group-container">
                  <FormControlLabel
                    value="Inventory"
                    control={<Radio />}
                    label={LBL_ITEM_TYPE_INVENTORY}
                  />
                  <FormControlLabel
                    value="NonInventory"
                    control={<Radio />}
                    label={LBL_ITEM_TYPE_NONINVENTORY}
                  />
                </div>
              </RadioGroup>
            </FormControl>
          </div>

          <span className="label-type">{LBL_TAX_PREFERENCE} </span>
          <div className="type-selection">
            <RadioGroup
              row
              aria-labelledby="tax-preference-radio-buttons-group-label"
              name="taxPreference"
              value={newItem.taxable ? "Taxable" : "Non-Taxable"}
              onChange={handleTaxableChange}
            >
              <div className="radio-group-container">
                <FormControlLabel
                  value="Taxable"
                  control={<Radio />}
                  label={LBL_TAXABLE}
                />
                <FormControlLabel
                  value="Non-Taxable"
                  control={<Radio />}
                  label={LBL_NON_TAXABLE}
                />
              </div>
            </RadioGroup>
          </div>
          {/* Multiple Items Checkbox */}
          <div className="type-selection">
            <span className="label-type">{LBL_MULTIPLE_ITEMS} </span>
            <label>
              <input
                type="checkbox"
                checked={newItem.createAttributes}
                onChange={handleAttributesChange}
              />
              {LBL_CREATE_ATTRIBUTES}
            </label>
          </div>
          {newItem.createAttributes && (
            <div className="attributes-options">
              {newItem.itemAttribute.map((attribute, idx) => (
                <div key={idx} className="attribute-section">
                  <div className="attribute-field">
                    <Select
                      className="dropdown-field"
                      // options={[
                      //   { value: "Size", label: "Size" },
                      //   { value: "Material", label: "Material" },
                      //   { value: "Color", label: "Color" },
                      // ]}
                      options={availableAttributes.map((attr) => ({
                        value: attr.id,
                        label: attr.name || "", // Fallback to an empty string if `name` is undefined
                      }))}
                      // value={{
                      //   value: attribute.attribute,
                      //   label: attribute.attribute,
                      // }}
                      value={
                        attribute.attribute
                          ? {
                              value: attribute.attribute,
                              label:
                                availableAttributes.find(
                                  (a) => a.id === attribute.attribute
                                )?.name || "",
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleAttributeOptionChange(
                          idx,
                          "attribute",
                          selectedOption
                        )
                      }
                      placeholder={PLACEHOLDER_SELECT_SIZE}
                      isSearchable
                    />
                  </div>
                  <div className="attribute-field">
                    <Select
                      className="dropdown-field"
                      // options={[
                      //   { value: "Red", label: "Red" },
                      //   { value: "Green", label: "Green" },
                      //   { value: "Blue", label: "Blue" },
                      //   { value: "Small", label: "Small" },
                      //   { value: "Large", label: "Large" },
                      //   { value: "Medium", label: "Medium" },
                      //   { value: "Material X", label: "Material X" },
                      //   { value: "Material Y", label: "Material Y" },
                      //   { value: "Material Z", label: "Material Z" },
                      // ]}
                      options={(attribute.availableOptions || []) // Use row-specific options
                        .map((attr) => ({
                          value: attr.id,
                          label: attr.name,
                        }))}
                      // value={
                      //   attribute.option
                      //     ? { value: attribute.option, label: attribute.option }
                      //     : { value: "Options", label: "Options" }
                      // }
                      value={
                        attribute.option
                          ? {
                              value: attribute.option,
                              label:
                                attribute.availableOptions?.find(
                                  (o) => o.id === attribute.option
                                )?.name || "",
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleAttributeOptionChange(
                          idx,
                          "option",
                          selectedOption
                        )
                      }
                      placeholder={PLACEHOLDER_SELECT_CATEGORY_OPTION}
                      isSearchable
                    />
                  </div>
                  {/* <button className="remove-button" onClick={() => handleRemoveAttributeOption(idx)}>
                      Remove
                    </button> */}
                  <img
                    className="remove-icon"
                    src="/icons8-delete-94.png"
                    alt="Remove"
                    onClick={() => handleRemoveAttributeOption(idx)}
                  />
                </div>
              ))}
              <button
                className="add-attribute"
                style={{ float: "right", marginRight: "50px" }}
                onClick={handleAddAttribute}
              >
                {LBL_ADD_ATTRIBUTE}
              </button>
            </div>
          )}

          {/* <button className="btn-add-item" onClick={handleAddItem}>
            {LBL_SAVE}
          </button> */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 2,
            }}
          >
            <Button
              variant="contained"
              onClick={handleAddItem}
              disabled={saving}
              className="btn-add-item"
            >
              {saving ? <CircularProgress size={20} color="inherit" /> : LBL_SAVE}
            </Button>
          </Box>
        </div>
      </Container>
      <Box
        sx={{
          position: "relative",
          left: 0,
          bottom: 0,
          width: "100%",
          mt: 10,
        }}
      >
        <Footer />
      </Box>
    </>
  );
};

export default EditInventory;
